export const BASE_URL = "https://karanmann.pythonanywhere.com/";
// export const BASE_URL = "http://localhost:8000/";
export const API_ENDPOINT_REGISTER_MEMBER = "accounts/user/register/";
export const API_ENDPOINT_LOGIN_MEMBER = "accounts/user/login/";
export const API_ENDPOINT_VERIFY_TOKEN = "accounts/user/verify/";
export const API_ENDPOINT_USER_LINK = "generator/file/";
export const API_ENDPOINT_USER_DETAILS = "accounts/user/";
export const WHATSAPP_URL = `https://wa.me/`;
